<template>
  <div class="user-info">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户详情 （{{user_name}}）</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <div>
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            size="small"
            v-model="key"
            @keyup.enter.native="Query"
          ></el-input>
        </div>
        <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      </div>
      <div class="export_btn"> <el-button type="success" size="small" @click.native="exportData()">导出记录</el-button></div>
    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          prop="game_name"
          label="游戏名"
          width="180">
        </el-table-column>
        <el-table-column
          prop="c_time"
          label="游戏时间">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="info" round size="small" @click="goTo('/user-info/game',scope.row.user_id,scope.row.game_name,scope.row.game_id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog
      title="选择导出时间范围"
      :visible.sync="centerDialogVisible"
      width="400px"
      center>
      <div align="center" class="time-screen">
        <el-tag :effect="time_name ===item.value? 'light':'plain'" v-for="(item,index) in time_list" @click="checkTime(item.value)" :key="index">{{item.name}}</el-tag>
        <el-date-picker
          v-model="time_slot"
          size="small"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="exportConfirm()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>


<script>
  export default {
    data() {
      return {
        user_name: decodeURI(this.$route.query.name),
        pages:1,
        limit: 10,
        key: '',
        tableData: [],
        total:0,
        centerDialogVisible: false,
        time_slot: ['',''],
        time_name: 'all',
        start_time: '',
        end_time: '',
        time_list:[
          {name:'今天',value:'today'},
          {name:'昨天',value:'yesterday'},
          {name:'近7天',value:'week'},
          {name:'近30天',value:'month'},
          {name:'全部',value:'all'}
        ],
      }
    },
    watch:{
      time_slot:function(val){
        if(val[0]){
          this.start_time= this.time_slot[0];
          this.end_time= this.time_slot[1];
          this.time_name = '';
        }
      }
    },
    methods: {
      getList(){
        this.$get('/v1/admin/users-game1?user_id=' + this.$route.query.user_id+ '&pages=' + this.pages + '&limit=' + this.limit+ '&key=' + this.key, {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.tableData = res.data.data.data;
              this.total = res.data.data.total;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      Query(){
        this.pages = 1;
        this.getList();
      },
      exportData(){
        this.centerDialogVisible = true;
      },
      checkTime(time_name) {
        this.start_time= '';
        this.end_time= '';
        this.time_slot = ['',''];
        this.time_name = time_name;
      },
      exportConfirm(){
        this.time_name = this.time_name==='all'?'':this.time_name;
        this.$getFile('/v1/admin/users-game-XL?user_id=' + this.$route.query.user_id+ '&start_time=' + this.start_time + '&end_time=' + this.end_time+ '&time_name=' + this.time_name, {})
          .then((res) => {
            console.log(res)
            if (res.status === 200) {
              this.downloadFile(res.data)
              this.centerDialogVisible = false
            } else {
              this.$msg(res.statusText)
            }
          });
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex %2 === 1) {
          return '';
        } else {
          return 'success-row';
        }
      },
      downloadFile(file){
        const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
        if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
          navigator.msSaveBlob(blob, this.filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = decodeURI(this.$route.query.name) +  '游戏列表.xlsx' //指定下载文件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      },
      handleSizeChange(val) {
        this.limit = val;
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pages = val;
        this.getList()
        console.log(`当前页: ${val}`);
      },
      goTo(path,user_id,game_name,game_id){
        this.$router.push({
          path:path,
          query: {
            user_name: this.user_name,
            user_id: user_id,
            game_name: encodeURI(game_name),
            game_id: game_id
          }
        })
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .user-info
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }
    .search
      margin 20px 0
      display flex
      justify-content space-between
      >div
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
    .list
      min-height 550px
      border 1px solid #EBEEF5
    .block
      margin-top:10px;
    .time-screen
      display flex
      justify-content space-between
      flex-wrap wrap
      >span
        cursor pointer
      >.el-date-editor
        wdith:100%;
        margin 20px 0 0;

</style>



// WEBPACK FOOTER //
// src/pages/UserManage/UserInfo.vue